import { useInfiniteQuery } from '@tanstack/react-query';
import { GetFeedResponse } from '@bitecritic-api/src/reviews/dto/get-feed.dto';
import { reviewsService } from '~/services/reviewsService/reviews.service';

export const useFeed = (isGlobalFeed: boolean) => {
  return useInfiniteQuery<GetFeedResponse>({
    queryKey: ['feed', isGlobalFeed],
    queryFn: ({ pageParam = 1 }) =>
      reviewsService.getFeed({
        page: pageParam as number,
        limit: 12,
        isGlobalFeed,
      }),
    getNextPageParam: (lastPage, allPages) =>
      lastPage.hasMore ? allPages.length + 1 : undefined,
    initialPageParam: 1,
  });
};
